<template>
  <div>
    <transition name="slide-fade">
      <div class="modal" v-show="modalData.addable">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">重置密码</h5>
              <button type="button" class="close" @click="closeClick">
                <i class="ki ki-close"></i>
              </button>
            </div>
            <div class="modal-body body_margin text-center">
              <div v-if="modalData.formShow">是否重置当前用户登录密码？</div>
              <div v-else>
                <div class="customer_account">
                  <div class="icon_box">
                    <vi-icon name="fas:check" :size="iconSize"></vi-icon>
                  </div>
                </div>
                <div class="mt-3">新密码：{{ modalData.password }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <div v-if="modalData.formShow">
                <button
                  type="button"
                  class="btn btn-primary font-weight-bold close_ctrl"
                  @click="confirmClick"
                >
                  确定
                </button>
                <button
                  type="button"
                  class="btn btn-light-dark font-weight-bold close_ctrl ml-2"
                  @click="cancelClick"
                >
                  取消
                </button>
              </div>
              <div v-else>
                <button
                  type="button"
                  class="btn btn-dark font-weight-bold close_ctrl"
                  @click="cormClick"
                >
                  复制并关闭
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="modal-backdrop" v-show="modalData.backdropShow"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AccountPasswordResetCtrl",
  data() {
    return {
      iconSize: "20px",
      newPassworld: "111",
    };
  },
  mounted() {},
  methods: {
    confirmClick() {
      this.$emit("e-confirm");
    },
    closeClick() {
      this.$emit("input", false);
    },
    cancelClick() {
      this.$emit("e-cancel");
      this.$emit("input", false);
    },
    cormClick() {
      this.eCopy();
      this.$emit("e-cancel");
    },
    eCopy() {
      let url = this.modalData.password;
      this.$$.clipboard.copyText(url);
      this.$$.toastr.success("复制成功！");
    },
  },
  props: {
    modalData: Object,
  },
};
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}
.modal-backdrop {
  transition: opacity 0.3s linear;
  opacity: 0.2;
}
.modal {
  display: block;
}
.custome_p {
  cursor: pointer;
}
.modal-footer {
  justify-content: center;
  border-top: none;
  .close_ctrl {
    width: 120px;
    color: #fff;
  }
}
.body_margin {
  .body_card {
    margin-top: 20px;
    div {
      margin: 5px 0px;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.body_title {
  font-size: 16px;
  color: #101010;
}
.customer_account {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.icon_box {
  width: 48px;
  height: 48px;
  background: #1bc5bd;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: #fff;
  }
}
</style>